/**
 * Mirror of backend kioskWinTickerService.js for first paint + offline fallback.
 * If you change bucket logic or item shape, update both files.
 */

export type WinTickerItem = {
  id: string;
  identity: string;
  amount: number;
  provider: string;
};

const PROVIDERS = [
  'Fire Kirin',
  'Game Vault',
  'Juwa 777',
  'Orion Stars',
  'Riverpay',
  'Vblink777',
  'VegasX',
  'Ultra Panda',
  'Blue Dragon',
  'Cash Frenzy',
];

const EMAIL_DOMAINS = ['gmail.com', 'outlook.com', 'yahoo.com'];

export const WIN_TICKER_INTERVAL_MS = 60 * 1000;

const ITEM_COUNT = 16;

function buildMaskedIdentity(index: number): string {
  if (index % 2 === 0) {
    const first = (index % 9) + 1;
    const tail = String((index * 373 + 91) % 10000).padStart(4, '0');
    return `+1 ${first}*** ***${tail}`;
  }
  const head = String.fromCharCode(97 + (index % 26));
  const tail = String((index * 37 + 11) % 100).padStart(2, '0');
  const domain = EMAIL_DOMAINS[index % EMAIL_DOMAINS.length];
  return `${head}***${tail}@${domain}`;
}

function roll01(bucket: number, index: number): number {
  let h = Math.imul(bucket ^ 0xdeadbeef, 0x9e3779b1) + Math.imul(index, 0x85ebca6b);
  h ^= h >>> 16;
  h = Math.imul(h, 0x7feb352d);
  h ^= h >>> 15;
  return (h >>> 0) / 4294967296;
}

function buildAmount(index: number, bucket: number): number {
  const base = 20 + ((index * 43 + 17) % 580);
  const roll = roll01(bucket, index);
  if (roll < 0.001) return 1000;
  if (roll < 0.002) return 2000;
  return base;
}

/** Same items the server would return for this bucket. */
export function buildWinTickerItemsForBucket(bucket: number): WinTickerItem[] {
  return Array.from({ length: ITEM_COUNT }, (_, index) => ({
    id: `win-${index}`,
    identity: buildMaskedIdentity(index),
    amount: buildAmount(index, bucket),
    provider: PROVIDERS[index % PROVIDERS.length],
  }));
}

export function currentWinTickerBucket(nowMs = Date.now()): number {
  return Math.floor(nowMs / WIN_TICKER_INTERVAL_MS);
}
